import { EnvironmentBanner } from "@common/components/layout";
import { NavBarLink, NavBarLinkWithHref } from '@common/components/layout/nav/NavBarLink';
import NavBarProfile from '@common/components/layout/nav/NavBarProfile';
import { Authorized } from '@common/components/trimming/Authorized';
import { EnvironmentWarning } from "@common/components/utility";
import { useApp } from '@common/hooks';
import { AuthOperationUINames } from '@common/models/Enums/AuthOperationStrings';
import { observer } from 'mobx-react';
import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { NavLink as NavLinkRR } from 'react-router-dom';
import uniqid from 'uniqid';

export const AdminNavBar = observer(() => {
    const { configuration } = useApp();
    return (<Navbar className="more-sticky" bg="primary" sticky="top" variant="dark" expand="xl" id={uniqid()}>
        <Container fluid>
            <Navbar.Brand className="petco-logo" as={NavLinkRR} to="/"></Navbar.Brand>
            <Navbar.Toggle />
            <Navbar.Collapse>
                <Nav className="root-links ms-xl-5">
                    <Nav.Item className="position-absolute bottom-2 align-self-center"><EnvironmentWarning isForHeader /></Nav.Item>
                </Nav>
                <Nav className="mx-auto mb-2 mb-lg-0">
                    <NavBarLink name="Hospital" route={'/login'} />
                    <NavBarLinkWithHref name="Clinic" route={`${appEnv.PETPASSURL}/cliniclisting`} />
                    <NavBarLinkWithHref name="Support" route={`${appEnv.PETPASSURL}/customerservice`} />
                    <Authorized if={configuration.HasUIFlag(AuthOperationUINames.UI_HospitalFlags_CanAccessHospitalAdmin)} >
                        <NavBarLink name="Hospital Admin" route="/admin" />
                    </Authorized>
                    <Authorized if={configuration.HasUIFlag(AuthOperationUINames.UI_HospitalFlags_CanAccessGlobalAdmin)} >
                        <Nav.Item>
                            <Nav.Link href={`${appEnv.GLOBALADMINURL}/admin`}>Global Admin</Nav.Link>
                        </Nav.Item>
                    </Authorized>
                </Nav>
                <NavBarProfile userId={configuration.userId} userInitials={configuration.userInitials} firstName={configuration.firstName} lastName={configuration.lastName} />
            </Navbar.Collapse>
        </Container >
        <EnvironmentBanner />
    </Navbar >)
});

export default AdminNavBar;
